import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LastLoggedInUser, ProductModel } from '@core/models';
import { AddItemToCartCommand, AddItemToWishlistCommand, CartItemModel, RemoveItemFromCartCommand, RemoveItemFromWishlistCommand, SkuResult, WishlistItemModel, WishlistModel } from '@core/services/api.service';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { AddItemToCartAction, RemoveItemFromCartAction } from '@ngxs-store/cart/cart.actions';
import { CartState } from '@ngxs-store/cart/cart.state';
import { AddItemToWishListAction, RemoveItemFromWishListAction } from '@ngxs-store/wish-list-store/wish-list.actions';
import { WishListState } from '@ngxs-store/wish-list-store/wish-list.state';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-shared-product-item',
    templateUrl: './shared-product-item.component.html',
    styleUrls: ['./shared-product-item.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductItemComponent implements OnChanges, OnInit {
    @Input() productItem: SkuResult;
    @Input() cartItem: CartItemModel;
    @Input() wishListItem: WishlistItemModel;
    @Input() isLoading: boolean;
    @Input() lastLoggedInUser: LastLoggedInUser;
    @Input() isGridView: boolean;
    @Input() returnUrl: any;
    @Input() wishlist: WishlistModel;
    @ViewChild('closeModal') private closeModalButtonElement: ElementRef

    InStock: string;
    product: ProductModel;
    hasValidToken = false;

    constructor(public store: Store, private router: Router, private toaster: ToastrService, private activatedRoute: ActivatedRoute) {
        this.hasValidToken = this.store.selectSnapshot(AuthState.getHasValidToken);
        this.InStock = "In Stock";
    }


    ngOnInit() {
        this.activatedRoute.params.subscribe((params) => {
            this.returnUrl = this.router.url.split('?')[0]
            localStorage.setItem('returnUrl', this.returnUrl);
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.productItem && changes.productItem.currentValue) {
            this.product = {
                skuCode: this.productItem.skuCode,
                skuSubCategory: this.productItem.skuSubCategory,
                skuBrand: this.productItem.skuBrand,
                imageUrl: this.productItem.imageUrl,
                packSize: this.productItem.packSize,
                capacity: this.productItem.capacity,
                skuCategory: this.productItem.skuCategory,
                skuDescription: this.productItem.skuDescription,
                listPriceIncl: this.productItem.listPriceIncl,
                listPriceExcl: this.productItem.listPriceExcl,
                discountPriceIncl: this.productItem.discountPriceIncl,
                discountPriceExcl: this.productItem.discountPriceExcl,
                discountPercentage: this.productItem.discountPercentage,
                stockOnHand: this.productItem.stockOnHand,
                isNewProduct: this.productItem.isNewProduct,
                dealReference: this.productItem.dealReference,
                quantity: 1
            }
        }

        if (changes.cartItem && changes.cartItem.currentValue) {
            this.product = {
                skuCode: this.cartItem.productId,
                skuSubCategory: this.cartItem.subCategory,
                skuBrand: this.cartItem.brand,
                imageUrl: this.cartItem.imageUrl,
                packSize: this.cartItem.packSize,
                capacity: this.cartItem.capacity,
                skuCategory: this.cartItem.category,
                skuDescription: this.cartItem.productDescription,
                listPriceIncl: this.cartItem.listPriceIncl,
                listPriceExcl: this.cartItem.listPriceExcl,
                discountPriceIncl: this.cartItem.discountPriceIncl,
                discountPriceExcl: this.cartItem.discountPriceExcl,
                discountPercentage: this.cartItem.discountPercentage,
                stockOnHand: this.cartItem.stockOnHand,
                isNewProduct: this.cartItem.isNewProduct,
                dealReference: this.cartItem.dealReference,
                quantity: this.cartItem.quantity
            }
        }

        if (changes.wishListItem && changes.wishListItem.currentValue) {
            this.product = {
                skuCode: this.wishListItem.productId,
                skuSubCategory: this.wishListItem.subCategory,
                skuBrand: this.wishListItem.brand,
                imageUrl: this.wishListItem.imageUrl,
                packSize: this.wishListItem.packSize,
                capacity: this.wishListItem.capacity,
                skuCategory: this.wishListItem.category,
                skuDescription: this.wishListItem.productDescription,
                listPriceIncl: this.wishListItem.listPriceincl,
                listPriceExcl: this.wishListItem.listPriceExcl,
                discountPriceIncl: this.wishListItem.discountPriceIncl,
                discountPriceExcl: this.wishListItem.discountPriceExcl,
                discountPercentage: this.wishListItem.discountPercentage,
                stockOnHand: this.wishListItem.stockOnHand,
                isNewProduct: this.wishListItem.isNewProduct,
                dealReference: this.wishListItem.dealReference,
                quantity: this.wishListItem.quantity
            }
        }
    }

    onWishlist(): boolean {
        return this.wishlist?.wishlistItems?.some(x => x.productId == this.product.skuCode) || this.wishListItem?.productId == this.product.skuCode;
    }

    removeFromWishList(product) {
        this.store.dispatch(new RemoveItemFromWishListAction({
            command: new RemoveItemFromWishlistCommand({
                skuCode: product.skuCode
            })
        }));

        this.closeModalButtonElement.nativeElement.click();
    }

    onQuantityUpdated(event: KeyboardEvent, product: ProductModel) {
        let cartItems = this.store.selectSnapshot(CartState.Cart).cartItems;
        let productIndex = cartItems.findIndex(prod => prod.productId === product.skuCode);
        let inputQuantity = (+(event.target as HTMLInputElement).value)
        let productOnCartQuantity = cartItems[productIndex]?.quantity

        if (productOnCartQuantity === inputQuantity) return;

        if (productOnCartQuantity < inputQuantity) {
            inputQuantity = inputQuantity - productOnCartQuantity
            this.addProductItemToCart(product, inputQuantity);
        } else {
            inputQuantity = productOnCartQuantity - inputQuantity;
            this.store.dispatch(new RemoveItemFromCartAction({
                command: new RemoveItemFromCartCommand({
                    skuCode: product.skuCode,
                    quantity: inputQuantity
                })
            }));
        }
    }

    returnUrls(url: any) {
        console.log(url);
        this.router.navigate(['/login']);
    }

    removeFromCart(product, remove) {
        this.store.dispatch(new RemoveItemFromCartAction({
            command: new RemoveItemFromCartCommand({
                skuCode: product.skuCode,
                remove: remove
            })
        }));
    }

    getProductQty(productId, items) {
        let index = items.findIndex(product => product.productId === productId);
        if (index != -1) {
            return items[index]?.quantity;
        } else {
            return 0;
        }
    }

    //add cart items to db
    addProductItemToCart(product: ProductModel, quantity) {
        if ((this.getProductQty(product.skuCode, this.store.selectSnapshot(CartState.Cart).cartItems) + quantity) <= 999) {
            if (product.listPriceIncl > 0) {
                this.store.dispatch(new AddItemToCartAction({
                    command: new AddItemToCartCommand({
                        skuCode: product.skuCode,
                        quantity: quantity,
                        dealReference: product.dealReference
                    })
                }));

                if (this.wishListItem) {
                    this.removeFromWishList(product);
                }

                this.closeModalButtonElement.nativeElement.click();
            } else {

                this.toaster.success("Please login, before you add to cart :) ", "Login", { timeOut: 5000 });
                this.router.navigate(['/login']);
            }
        } else {
            this.toaster.error("Please ensure quantity is less than 1000 ", "Quantity Limit", { timeOut: 5000 });
        }
    }

    //add cart items to db
    addItemToWishlist(product: ProductModel, quantity) {
        if ((this.getProductQty(product.skuCode, this.store.selectSnapshot(WishListState.getItems).wishlistItems) + quantity) <= 999) {

            if (product.listPriceIncl > 0) {
                this.store.dispatch(new AddItemToWishListAction({
                    command: new AddItemToWishlistCommand({
                        skuCode: product.skuCode,
                        quantity: quantity,
                        dealReference: product.dealReference
                    })
                }));
            } else {
                this.toaster.success("Please login, before you add to wishlist :) ", "Login", { timeOut: 5000 });
                this.router.navigate(['/login']);
            }
        } else {
            this.toaster.error("Please ensure quantity is less than 1000 ", "Quantity Limit", { timeOut: 5000 });
        }
    }
}
